export default "__VITE_ASSET__BiOE8peC__"